import { environment } from '@lla-platform/core/core-util'

export const ATTENDANCE_API_URL = {
  getAttendance: `${environment.apiUrl}/attendance`,
  resyncAttendance: `${environment.apiUrl}/attendance/resync`,
  employeeAttendanceDetails: (employeeId: string) =>
    `${environment.apiUrl}/attendance/details/${employeeId}`
}
